import { CommunityMemberList } from './CommunityMemberList.js'
import { SpaceMemberList } from './SpaceMemberList.js'

export const MemberList = ({ spaceId }) => {
  if (spaceId) {
    return <SpaceMemberList spaceId={spaceId} />
  }
  return <CommunityMemberList />
}
